import { ComponentPropsWithoutRef } from "react";
import { Tabs as PrimitiveTabs } from "radix-ui";
import classNames from "classnames";
import styles from "./Tabs.module.scss";

type TabsProps = ComponentPropsWithoutRef<typeof PrimitiveTabs.Root>;

const Tabs = ({ className, orientation = "horizontal", children, ...props }: TabsProps) => {
	return (
		<PrimitiveTabs.Root
			{...props}
			className={classNames(styles.tabs, className)}
			data-orientation={orientation}
		>
			{children}
		</PrimitiveTabs.Root>
	);
};

type TabsListProps = ComponentPropsWithoutRef<typeof PrimitiveTabs.List>;

const TabsList = ({ className, children, ...props }: TabsListProps) => {
	return (
		<PrimitiveTabs.List className={classNames(styles["tabs__list"], className)} {...props}>
			{children}
		</PrimitiveTabs.List>
	);
};

type TabsTriggerProps = ComponentPropsWithoutRef<typeof PrimitiveTabs.Trigger>;

const TabsTrigger = ({ className, children, value, ...props }: TabsTriggerProps) => {
	return (
		<PrimitiveTabs.Trigger
			className={classNames(styles["tabs__trigger"], className)}
			value={value}
			{...props}
		>
			{children}
		</PrimitiveTabs.Trigger>
	);
};

type TabsContentProps = ComponentPropsWithoutRef<typeof PrimitiveTabs.Content>;

const TabsContent = ({ className, children, value, ...props }: TabsContentProps) => {
	return (
		<PrimitiveTabs.Content
			className={classNames(styles["tabs__content"], className)}
			value={value}
			{...props}
		>
			{children}
		</PrimitiveTabs.Content>
	);
};

export { Tabs, TabsList, TabsTrigger, TabsContent };
